"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importsLatestSalesforceSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const api_1 = require("../../api/index.js");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
exports.importsLatestSalesforceSlice = (0, xuder_1.createGetAsyncSlice)({
    name: 'ImportsLatestSalesforce',
    receive: true,
    request: false,
    requestHandler: () => (0, api_1.getLatestImports)({
        count: 1,
        organizationTypeId: sonar_ts_types_1.OrganizationTypeId.Salesforce
    }),
    retainDataOnRequest: true
});
//# sourceMappingURL=salesforce.js.map